export interface DiffDisplay {
  currentMarkdown: string;
  previousMarkdown: string;
}

export const DATA_KEY_EDIT_TOOL_NAMES = new Set([
  "edit_data_key",
  "write_data_key",
]);

export const getPartialEditDiffDisplay = (
  args: Record<string, unknown>
): DiffDisplay | null => {
  const hasOldString = typeof args.old_string === "string";
  const hasNewString = typeof args.new_string === "string";

  if (!hasOldString || !hasNewString) {
    return null;
  }

  if (args.old_string === args.new_string) {
    return null;
  }

  const oldString = args.old_string as string;
  const newString = args.new_string as string;

  return {
    currentMarkdown: newString,
    previousMarkdown: oldString,
  };
};
